<template>
  <v-dialog v-model="dialog" persistent width="450">
    <v-card v-if="phase === 1">
      <v-card-title>
        Passo 1 - Foto principal
        <v-spacer></v-spacer>
        <v-btn @click="close()" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col>
            Adicione um fotografia que apresente o equipamento danificado.
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <PhotoPicker v-model="mainPhoto" :insurer="insurer" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          @click="handleGoToPhase2()"
          block
          :disabled="!mainPhoto"
          :dark="!!mainPhoto"
          :color="insurer.color"
          large
        >
          Continuar
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="phase === 2">
      <v-card-title>
        Passo 2 - Características
        <v-spacer></v-spacer>
        <v-btn @click="close()" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col>
            Adicione uma fotografia da etiqueta de características do
            equipamento danificado.
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <PhotoPicker v-model="labelPhoto" :insurer="insurer" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          @click="handleGoToPhase3()"
          block
          :disabled="!labelPhoto"
          :dark="!!labelPhoto"
          :color="insurer.color"
          large
        >
          Continuar
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="phase === 3">
      <v-card-title>
        Passo 3 - Documento
        <v-spacer></v-spacer>
        <v-btn @click="close()" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-row class="mb-2">
          <v-col>
            Adicione a fatura ou orçamento do equipamento que reclama, caso os
            tenha na sua posse, para que possam ser avaliados.
          </v-col>
        </v-row>

        <v-radio-group v-model="budgetType" :color="insurer.color">
          <v-radio
            label="Tenho factura"
            :value="1"
            :color="insurer.color"
          ></v-radio>
          <v-radio
            label="Tenho orçamento"
            :value="2"
            :color="insurer.color"
          ></v-radio>
          <v-radio
            label="Ainda não tenho fatura ou orçamento"
            :value="3"
            :color="insurer.color"
          ></v-radio>
        </v-radio-group>

        <v-file-input
          class="mt-3"
          v-if="[1, 2].includes(budgetType)"
          v-model="budget"
          label="Documento a enviar"
          :color="insurer.color"
          prepend-icon=""
          prepend-inner-icon="mdi-paperclip"
          outlined
          dense
        ></v-file-input>
      </v-card-text>
      <v-card-actions>
        <v-btn
          @click="handleGoToPhase4()"
          block
          :color="insurer.color"
          large
          dark
        >
          Continuar
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="phase === 4">
      <v-card-title>
        Passo 4 - Localização
        <v-spacer></v-spacer>
        <v-btn @click="close()" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-row class="mb-2">
          <v-col> Indique onde se encontra o equipamento danificado. </v-col>
        </v-row>

        <v-radio-group v-model="equipamentLocation" :color="insurer.color">
          <v-radio
            label="Na minha residência"
            value="insured"
            :color="insurer.color"
          ></v-radio>
          <v-radio
            label="Num reparador externo"
            value="repairman"
            :color="insurer.color"
          ></v-radio>
        </v-radio-group>

        <div v-if="equipamentLocation === 'repairman'">
          <v-card flat color="#f1f1f1" :disabled="loadingRepairman">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="subtitle-2">
                  Dados do reparador
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-card-text>
              <v-row dense>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="repairman.nif"
                    @input="handleInputNif"
                    :color="insurer.color"
                    label="NIF"
                    hide-details="auto"
                    dense
                    outlined
                    :loading="loadingRepairman"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="repairman.phone"
                    :color="insurer.color"
                    label="Contacto"
                    hide-details="auto"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <v-text-field
                    v-model="repairman.name"
                    :color="insurer.color"
                    label="Nome"
                    hide-details="auto"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <v-text-field
                    v-model="repairman.address"
                    :color="insurer.color"
                    label="Morada"
                    hide-details="auto"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn
          @click="handleGoToPhase5()"
          :disabled="!equipamentLocationValidated"
          block
          :color="insurer.color"
          large
          :dark="equipamentLocationValidated"
        >
          Continuar
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="phase === 5">
      <v-card-title>
        Confirmação
        <v-spacer></v-spacer>
        <v-btn @click="close()" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <div class="ml-2">Equipamento</div>
        <div
          v-if="loadingProductData"
          style="width: 100%"
          class="text-center my-6"
        >
          <v-progress-circular
            indeterminate
            :color="insurer.color"
            class="text-center mx-auto"
          ></v-progress-circular>
          <div class="text-center mt-2">A analizar fotografias enviadas...</div>
        </div>
        <v-alert v-if="productError" type="error">
          Não foi possível carregar os dados do produto
          <v-btn @click="loadProductData()" small outlined class="ma-2">
            <v-icon>mdi-refresh</v-icon>
            Reprocessar
          </v-btn>
        </v-alert>
        <v-simple-table v-if="productData !== null" class="mt-3" dense>
          <tbody>
            <tr>
              <th width="100px">Categoria</th>
              <td>
                {{ productData.product_type || "---" }}
                <v-btn
                  @click="handleClickEditCategory()"
                  small
                  :color="insurer.color"
                  icon
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr>
              <th>Marca</th>
              <td>
                {{ productData.brand || "---" }}
                <v-btn
                  @click="handleClickEditBrand()"
                  small
                  :color="insurer.color"
                  icon
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr>
              <th>Modelo</th>
              <td>
                {{ productData.model || "---" }}
                <v-btn
                  @click="handleClickEditModel()"
                  small
                  :color="insurer.color"
                  icon
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr>
              <th>EAN</th>
              <td>
                {{ productData.ean || "---" }}
                <v-btn
                  @click="handleClickEditEan()"
                  small
                  :color="insurer.color"
                  icon
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <div v-if="[1, 2].includes(this.budgetType)" class="ml-2 mt-5">
          Documento
        </div>
        <div
          v-if="loadingInvoiceData"
          style="width: 100%"
          class="text-center my-6"
        >
          <v-progress-circular
            indeterminate
            :color="insurer.color"
            class="text-center mx-auto"
          ></v-progress-circular>
          <div class="text-center mt-2">A analizar anexo enviado...</div>
        </div>
        <v-alert v-if="invoiceError" type="error">
          Não foi possível carregar os dados do documento anexado
          <v-btn @click="loadInvoiceData()" small outlined class="ma-2">
            <v-icon>mdi-refresh</v-icon>
            Reprocessar
          </v-btn>
        </v-alert>
        <v-simple-table v-if="invoiceData" class="mt-3" dense>
          <tbody>
            <tr>
              <th width="100px">Tipo</th>
              <td>
                {{ budgetTypeDescription }}
                <v-btn
                  @click="handleClickEditBudgetType()"
                  small
                  :color="insurer.color"
                  icon
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr>
              <th>Total</th>
              <td>
                {{ euro(invoiceData.total_amount) }}
                <v-btn
                  @click="handleClickEditInvoiceTotal()"
                  small
                  :color="insurer.color"
                  icon
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr>
              <th>Emissor</th>
              <td>
                {{ invoiceData.issuer_name }}
                <v-btn
                  @click="handleClickEditIssuerName()"
                  small
                  :color="insurer.color"
                  icon
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr>
              <th>NIF</th>
              <td>
                {{ invoiceData.issuer_nif }}
                <v-btn
                  @click="handleClickEditIssuerNif()"
                  small
                  :color="insurer.color"
                  icon
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr>
              <th>Contacto</th>
              <td>
                {{ invoiceData.issuer_phone }}
                <v-btn
                  @click="handleClickEditIssuerContact()"
                  small
                  :color="insurer.color"
                  icon
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-btn
          :disabled="!validated"
          @click="handleConfirm"
          block
          :color="insurer.color"
          large
          :dark="validated"
        >
          Confirmar
        </v-btn>
      </v-card-actions>

      <TextFieldDialog
        ref="brandDialog"
        title="Alterar marca"
        fieldLabel="Marca"
        pleceholder="Digite a marca do equipamento"
        @submit="handleSubmitBrandDialog"
        :color="insurer.color"
        dark
      ></TextFieldDialog>

      <TextFieldDialog
        ref="modelDialog"
        title="Alterar modelo"
        fieldLabel="Modelo"
        pleceholder="Digite o modelo do equipamento"
        @submit="handleSubmitModelDialog"
        :color="insurer.color"
        dark
      ></TextFieldDialog>

      <TextFieldDialog
        ref="eanDialog"
        optional
        title="Alterar EAN"
        fieldLabel="EAN"
        pleceholder="Digite o EAN do equipamento"
        @submit="handleSubmitEanDialog"
        :color="insurer.color"
        dark
      ></TextFieldDialog>

      <TextFieldDialog
        ref="categoryDialog"
        title="Alterar Categoria"
        fieldLabel="Categoria"
        pleceholder="Digite a categoria do equipamento"
        @submit="handleSubmitCategoryDialog"
        :color="insurer.color"
        dark
      ></TextFieldDialog>

      <!-- Invoice -->
      <MoneyFieldDialog
        ref="totalDialog"
        title="Alterar total"
        placeholder="Digite o total"
        @submit="handleSubmitTotalDialog"
        :color="insurer.color"
        dark
      ></MoneyFieldDialog>

      <TextFieldDialog
        ref="issuerNameDialog"
        title="Alterar emissor"
        fieldLabel="Nome"
        pleceholder="Digite o nome do emissor"
        @submit="handleSubmitIssuerNameDialog"
        :color="insurer.color"
        dark
      ></TextFieldDialog>

      <TextFieldDialog
        ref="issuerNifDialog"
        title="Alterar NIF"
        fieldLabel="NIF"
        pleceholder="Digite o nif do emissor"
        @submit="handleSubmitIssuerNifDialog"
        :color="insurer.color"
        dark
      ></TextFieldDialog>

      <TextFieldDialog
        ref="issuerContactDialog"
        title="Alterar Contacto"
        fieldLabel="Contacto"
        pleceholder="Digite o contacto do emissor"
        @submit="handleSubmitIssuerContactDialog"
        :color="insurer.color"
        dark
      ></TextFieldDialog>

      <RadioFieldDialog
        ref="budgetTypeDialog"
        title="Alterar tipo de anexo"
        fieldLabel="Tipo"
        @submit="handleSubmitBudgetTypeDialog"
        :color="insurer.color"
        dark
        :items="[
          {
            value: 1,
            label: 'Factura',
          },
          {
            value: 2,
            label: 'Orçamento',
          },
        ]"
      ></RadioFieldDialog>
    </v-card>
  </v-dialog>
</template>

<script>
import PhotoPicker from "./PhotoPicker.vue";
import { analyse, analyseInvoice } from "../../services/customer_inbound";
import { euro } from "@/tools/money";
import Formatter from "@/tools/money";
import TextFieldDialog from "../dialogs/TextFieldDialog.vue";
import MoneyFieldDialog from "../dialogs/MoneyFieldDialog.vue";
import RadioFieldDialog from "../dialogs/RadioFieldDialog.vue";

export default {
  mixins: [],

  components: {
    PhotoPicker,
    TextFieldDialog,
    MoneyFieldDialog,
    RadioFieldDialog,
  },

  props: {
    insurer: Object,
  },

  data() {
    return {
      dialog: false,
      phase: 1,
      mainPhoto: null,
      labelPhoto: null,
      budget: null,
      budgetType: null,

      loadingProductData: false,
      productData: null,
      productError: false,

      loadingInvoiceData: false,
      invoiceData: null,
      invoiceError: false,

      equipamentLocation: "insured",
      repairman: {},
      loadingRepairman: false,

      euro: Formatter.euro,
    };
  },

  methods: {
    open() {
      this.phase = 1;
      this.mainPhoto = null;
      this.labelPhoto = null;
      this.budget = null;
      this.budgetType = null;

      this.loadingProductData = false;
      this.productData = null;
      this.productError = false;

      this.loadingInvoiceData = false;
      this.invoiceData = null;
      this.invoiceError = false;

      this.repairman.nif = "";
      this.repairman.name = "";
      this.repairman.phone = "";
      this.repairman.address = "";
      this.equipamentLocation = "insured";

      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    handleGoToPhase2() {
      this.phase = 2;
    },
    handleGoToPhase3() {
      this.phase = 3;
      this.loadProductData();
    },
    handleGoToPhase4() {
      this.phase = 4;
      this.loadInvoiceData();
    },
    handleGoToPhase5() {
      this.phase = 5;
    },
    async loadProductData() {
      this.loadingProductData = true;
      this.productError = false;

      try {
        const { response } = await analyse([this.mainPhoto, this.labelPhoto]);
        console.log(response);
        this.productData = response;
      } catch (error) {
        this.productError = true;
        console.error(error);
      } finally {
        this.loadingProductData = false;
      }
    },
    async loadInvoiceData() {
      if (![1, 2].includes(this.budgetType)) {
        return;
      }

      if (!this.budget) {
        return;
      }

      this.loadingInvoiceData = true;
      this.invoiceError = false;
      try {
        const { response } = await analyseInvoice(this.budget);
        console.log(response);
        this.invoiceData = response;
      } catch (error) {
        console.error(error);
        this.invoiceError = true;
      } finally {
        this.loadingInvoiceData = false;
      }
    },
    formatEuro(money) {
      return euro(money);
    },
    handleConfirm() {
      this.$emit("create", {
        product: { ...this.productData },
        invoice: this.invoiceData === null ? null : { ...this.invoiceData },
        equipamentLocation: this.equipamentLocation,
        repairman:
          this.equipamentLocation === "repairman"
            ? { ...this.repairman }
            : null,
      });
      this.close();
    },
    async handleInputNif(nif) {
      if (nif.length < 9) {
        return;
      }

      this.loadingRepairman = true;
      this.repairman.name = "";
      this.repairman.phone = "";
      this.repairman.address = "";

      setTimeout(() => {
        this.repairman = {
          ...this.repairman,
          name: "Moreplay Eletrodomesticos, Unipessoal Lda",
          phone: "935 788 850",
          address: "Rua Sampaio Pina, nº 80, R/C, 1070-250 Lisboa, Lisboa",
        };
        this.loadingRepairman = false;
      }, 1000);
    },
    // Brand
    handleClickEditBrand() {
      this.$refs.brandDialog.open(this.productData.brand);
    },

    handleSubmitBrandDialog(newBrand) {
      this.productData.brand = newBrand;
    },

    // Model
    handleClickEditModel() {
      this.$refs.modelDialog.open(this.productData.model);
    },

    handleSubmitModelDialog(payload) {
      this.productData.model = payload;
    },

    // EAN
    handleClickEditEan() {
      this.$refs.eanDialog.open(this.productData.ean);
    },

    handleSubmitEanDialog(payload) {
      this.productData.ean = payload;
    },

    // Categoria
    handleClickEditCategory() {
      this.$refs.categoryDialog.open(this.productData.product_type);
    },

    handleSubmitCategoryDialog(payload) {
      this.productData.product_type = payload;
    },

    // Total da fatura
    handleClickEditInvoiceTotal() {
      this.$refs.totalDialog.open(this.invoiceData.total_amount);
    },

    handleSubmitTotalDialog(payload) {
      this.invoiceData.total_amount = payload;
    },

    // Nome do emissor
    handleClickEditIssuerName() {
      this.$refs.issuerNameDialog.open(this.invoiceData.issuer_name);
    },

    handleSubmitIssuerNameDialog(payload) {
      this.invoiceData.issuer_name = payload;
    },

    // NIF do emissor
    handleClickEditIssuerNif() {
      this.$refs.issuerNifDialog.open(this.invoiceData.issuer_nif);
    },

    handleSubmitIssuerNifDialog(payload) {
      this.invoiceData.issuer_nif = payload;
    },

    // Contacto do emissor
    handleClickEditIssuerContact() {
      this.$refs.issuerContactDialog.open(this.invoiceData.issuer_phone);
    },

    handleSubmitIssuerContactDialog(payload) {
      this.invoiceData.issuer_phone = payload;
    },

    // Tipo de anexo
    handleClickEditBudgetType() {
      this.$refs.budgetTypeDialog.open(this.budgetType);
    },

    handleSubmitBudgetTypeDialog(payload) {
      this.budgetType = payload;
    },
  },

  computed: {
    budgetTypeDescription() {
      if (this.budgetType === 1) {
        return "Factura";
      }

      if (this.budgetType === 2) {
        return "Orçamento";
      }

      return "---";
    },

    equipamentLocationValidated() {
      // if (this.equipamentLocation === "repairman") {
      //   if (this.repairman.name.length < 1) {
      //     console.log("without name");
      //     return false;
      //   }
      //   if (this.repairman.phone.length < 1) {
      //     console.log("without phone");
      //     return false;
      //   }
      //   if (this.repairman.address.length < 1) {
      //     console.log("without address");
      //     return false;
      //   }
      // }

      return true;
    },

    validated() {
      if (this.equipamentLocation === "repairman") {
        if (!this.repairman.name) {
          return false;
        }
        if (!this.repairman.phone) {
          return false;
        }
        if (!this.repairman.address) {
          return false;
        }
      }

      if (!this.productData) {
        return false;
      }

      if ([1, 2].includes(this.budgetType) && !this.invoiceData) {
        return false;
      }

      return true;
    },
  },
};
</script>
